import React from "react";
import { Grid } from "@mui/material";
import { FormProvider } from "react-hook-form";
import {
  EnhancedDialog,
  RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { EnhancedButtonPrimeReact } from "../../../src/components/EnhancedButtonPrimeReact/index";
import { EnhancedButtonPrimeReactSeverity } from "../../common/Common";

interface ItsReallyYouModalProps {
  open: boolean;
  onClose: () => void;
  formMethods: any;
  onSubmit: (data: any) => void;
  defaultMethodsCheck: "phone" | "google";
  loading: boolean;
  showSendOtpButton?: boolean;
  onClickSendOtp?: () => void;
}

const ItsReallyYouImportModal: React.FC<ItsReallyYouModalProps> = ({
  open,
  onClose,
  formMethods,
  onSubmit,
  defaultMethodsCheck,
  loading,
  showSendOtpButton = false,
  onClickSendOtp,
}) => {
  return (
    <EnhancedDialog
      dialogTitle="Please Confirm"
      key="dialog-box"
      testId="dialog"
      open={open}
      onCloseHandler={onClose}
      dialogContent={
        <FormProvider {...formMethods}>
          <form onSubmit={formMethods.handleSubmit(onSubmit)}>
            <Grid container spacing={2}>
              <h4>Just making sure it's really you — please verify.</h4>
              <Grid container spacing={2}>
                <RHookFormTextFieldWithLabel
                  label={
                    defaultMethodsCheck === "phone"
                      ? "Enter code sent to your phone"
                      : "Enter code from linked google authenticator"
                  }
                  id="otp"
                  testId="otp"
                  placeholder="Enter OTP"
                />
              </Grid>
            </Grid>
          </form>
        </FormProvider>
      }
      showdividers={false}
      dialogAction={
        <Grid>
          <EnhancedButtonPrimeReact
            label="Verify"
            loading={loading}
            type="submit"
            raised
            style={{
              marginLeft: defaultMethodsCheck === "phone" ? "3.8rem" : "8.8rem",
            }}
            onClickHandler={formMethods.handleSubmit(onSubmit)}
            severity={EnhancedButtonPrimeReactSeverity.Success}
          />
          {showSendOtpButton && (
            <EnhancedButtonPrimeReact
              label="Send OTP"
              raised
              style={{ marginLeft: "1rem" }}
              onClickHandler={onClickSendOtp}
              severity={EnhancedButtonPrimeReactSeverity.Secondary}
            />
          )}
        </Grid>
      }
    />
  );
};

export default ItsReallyYouImportModal;
